<template>
  <main>
    <section v-for="(activity, index) in project.activities"
             class="box"
             :key="activity.id"
    >
      <div class="field is-horizontal">
        <div class="field-label">
          <label class="label">กิจกรรมที่ {{ index + 1 }}</label>
        </div>
        <div class="field-body">
          <input class="input" type="hidden"
                 :name="'activities[' + index + '][id]'"
                 v-model="activity.id"
          />
          <input class="input" type="hidden"
                 :name="'activities[' + index + '][index]'"
                 v-model="activity.index"
          />
          <textarea class="textarea"
                    :name="'activities[' + index + '][title]'"
                    rows="1"
                    v-model="activity.title"
                    v-autosize
          ></textarea>
        </div>
      </div>
      <div class="field is-horizontal">
        <div class="field-label">
          <label class="label">สถานที่</label>
        </div>
        <div class="field-body">
                        <textarea class="textarea"
                                  :name="'activities[' + index + '][place]'"
                                  rows="1"
                                  v-model="activity.place"
                                  v-autosize
                        ></textarea>
        </div>
      </div>

      <div class="field is-horizontal">
        <div class="field-label">
          <label class="label">จังหวัด</label>
        </div>
        <div class="field-body">

          <v-select multiple
                    class="w-full lg:w-1/2 xl:w-1/3"
                    :options="provinces"
                    :taggable="false"
                    v-model="activity.provinces_array"
          >
          </v-select>
          <input type="hidden" :name="'activities[' + index + '][provinces]'"
                 :value="activity.provinces_array"
          />
        </div>
      </div>
      <div class="field is-horizontal">
        <div class="field-label">
          <label class="label">ระยะเวลาดำเนินกิจกรรม</label>
        </div>
        <div class="field-body">
          <p class="control">
            <vue-datepicker :name="'activities[' + index + '][start_date]'"
                            v-model="activity.start_date"
                            @change="handleStartDateChange(activity, index)"
                            :min-date="project.min_start_date"
            />
          </p>
          <div class="control">
            <p class="label">&nbsp;ถึง&nbsp;</p>
          </div>
          <p class="control">
            <vue-datepicker :name="'activities[' + index + '][end_date]'"
                            :min-date="activity.start_date"
                            v-model="activity.end_date"
                            ref="endDate"
            />
          </p>
        </div>
      </div>
      <div class="field is-horizontal">
        <div class="field-label">
          <label class="label">กลุ่มเป้าหมาย</label>
        </div>
        <div class="field-body is-block">
          <ProjectActivitiesAttendees :type="ATTENDEE_TYPES.INTERNAL"
                                      :activity-index="index"
                                      :activity="activity"
          />
          <ProjectActivitiesAttendees :type="ATTENDEE_TYPES.EXTERNAL"
                                      :activity-index="index"
                                      :activity="activity"
          />
        </div>
      </div>
      <div class="field is-horizontal">
        <div class="field-label">
          <label class="label">จำนวนผู้เข้าร่วมกิจกรรม {{ index + 1 }}</label>
        </div>
        <div class="field-body">
          <div class="field">
            {{ numActivityAttendees(activity) }} คน
          </div>
        </div>
      </div>

      <div class="flex">
        <button class="button is-white is-small ml-auto"
                @click.prevent="deleteActivity(index)"
        >
          <span class="delete"></span>
          &nbsp; ลบกิจกรรม
        </button>
      </div>

    </section>
    <section class="mt-2">
      <div class="box">
        <div class="level">
          <div class="level-left">
            <button type="button" class="button is-large is-info level-item"
                    @click.prevent="addActivity"
            >
              <span class="icon"><i class="fa fa-plus"></i></span> &nbsp;
              เพิ่มกิจกรรม
            </button>
          </div>
          <div class="level-item is-block ml-2">
            <p class="text-xl">
              รวมทั้งสิ้น
              <strong class="text-purple">{{ project.activities.length }} กิจกรรม</strong>
            </p>
            <p class="text-lg">
              จำนวนผู้เข้าร่วมโครงการ
              <strong class="text-blue">{{ total_attendees }} คน</strong>
            </p>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>
<script type="text/babel">
import ProjectActivitiesAttendees from './ProjectActivitiesAttendees';

export default {
  components: {
    ProjectActivitiesAttendees
  },
  props: {
    project: {type: Object, required: true},
  },

  data() {
    return {
      ATTENDEE_TYPES,
      provinces
    }
  },

  computed: {
    attendees() {
      return _.flatten(
          _.map(this.project.activities, (activities) => activities.attendees)
      );
    },
    total_attendees() {
      return _.sumBy(this.attendees, (attendee) => !_.isNull(attendee.num_attendees) ? parseInt(attendee.num_attendees) : 0);
    }
  },
  created() {
    if (this.project.activities.length == 0) {
      this.addActivity();
    }
  },
  methods: {
    addActivity() {
      this.project.activities.push({
        id: null,
        title: null,
        start_date: null,
        end_date: null,
        is_grantt: true,
        total_attendees: 0,
        attendees: []
      })
    },
    deleteActivity(index) {
      this.project.activities.splice(index, 1);
    },
    numActivityAttendees(activity) {
      return _.sumBy(activity.attendees, (attendee) => !_.isNull(attendee.num_attendees) ? parseInt(attendee.num_attendees) : 0);
    },
    handleStartDateChange(activity, index) {
      if (!_.isEmpty(activity.end_date) && moment(activity.start_date).isBefore(activity.end_date)) {
        return;
      }

      this.$refs.endDate[index].setDate(activity.start_date);
    }
  }
}
</script>
